import { render, staticRenderFns } from "./fluxStatistics.vue?vue&type=template&id=5e00edf6&scoped=true&"
import script from "./fluxStatistics.vue?vue&type=script&lang=js&"
export * from "./fluxStatistics.vue?vue&type=script&lang=js&"
import style0 from "./fluxStatistics.vue?vue&type=style&index=0&lang=css&"
import style1 from "./fluxStatistics.vue?vue&type=style&index=1&id=5e00edf6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e00edf6",
  null
  
)

export default component.exports